export var VoiceEnrolmentAppEventAction;
(function (VoiceEnrolmentAppEventAction) {
    VoiceEnrolmentAppEventAction["recordVoiceprint"] = "recordVoiceprint";
    VoiceEnrolmentAppEventAction["failedVoiceprint"] = "failedVoiceprint";
    VoiceEnrolmentAppEventAction["declineTerms"] = "declineTerms";
    VoiceEnrolmentAppEventAction["successVoiceprint"] = "successVoiceprint";
    VoiceEnrolmentAppEventAction["declineVoiceprint"] = "declineVoiceprint";
    VoiceEnrolmentAppEventAction["vpTermsConditions"] = "vpTermsConditions";
})(VoiceEnrolmentAppEventAction || (VoiceEnrolmentAppEventAction = {}));
export var Click2CallAppEventAction;
(function (Click2CallAppEventAction) {
    Click2CallAppEventAction["click2callAccepted"] = "click2callAccepted";
    Click2CallAppEventAction["click2callDeclined"] = "click2callDeclined";
})(Click2CallAppEventAction || (Click2CallAppEventAction = {}));
export var ChannelSwapAppEventAction;
(function (ChannelSwapAppEventAction) {
    ChannelSwapAppEventAction["requestSecurityToken"] = "requestSecurityToken";
})(ChannelSwapAppEventAction || (ChannelSwapAppEventAction = {}));
export const APP_EVENT_TYPES = [
    'trackEvent',
    'click2call',
    'webchat/status',
    'voiceEnrolment',
    'channelSwap'
];
export const APP_INTENT_TYPES = [
    'welcome',
    'startVoice',
    'startVoiceEnrolment',
    'vpFailedRecordingClosed',
    'vpTermsAccept',
    'vpTermsDecline',
    'vpFailedMaxAttempts',
    'vpFailedInconsistentAudio',
    'vpFailedGeneric',
    'vpFailedPermissionDenied',
    'vpFailedPermissionDeniedAlways',
    'vpSuccessTrain',
    'channelSwapSecurityToken',
    'channelSwapTimeout'
];
export const MESSAGE_EVENTS = [
    'webchat/intent',
    'webchat/startReiClick2CallHandoff'
];
//# sourceMappingURL=app-events.js.map